import React from 'react';
import MaskedInput from 'react-text-mask';

import {
  FormControl,
  OutlinedInput,
  InputLabel,
  FormHelperText,
} from '@material-ui/core';
import { useField } from 'formik';
import { at } from 'lodash';

interface TextMaskCustomProps {
  inputRef: (ref: HTMLInputElement | null) => void;
}

function TextMaskCustom(props: TextMaskCustomProps) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      placeholderChar={'\u2000'}
    />
  );
}

interface ComponentProps {
  name: string;
  // eslint-disable-next-line react/require-default-props
  label?: string;
  placeholder?: string;
  fullWidth: boolean;
  mask?: Array<any>;
}

const InputFieldMask: React.FC<ComponentProps> = (props: any) => {
  const { mask, label, placeholder, ...rest } = props;
  const [field, meta] = useField(props);

  function renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return error;
    }
    return null;
  }

  return (
    <FormControl variant="outlined" fullWidth error={!!renderHelperText()}>
      <InputLabel htmlFor="component-outlined">{label}</InputLabel>
      <OutlinedInput
        label={label}
        inputComponent={TextMaskCustom as any}
        inputProps={{
          mask,
          placeholder,
        }}
        aria-describedby="component-error-text"
        error={meta.touched && meta.error && true}
        {...field}
        {...rest}
      />
      {!!renderHelperText() && (
        <FormHelperText id="component-error-text">
          {renderHelperText()}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default InputFieldMask;
